import "../Home-page.scss";
import { Grid } from "@mui/material";
import showcasePrompt from "../assets/showcase-prompt.png";
import showcaseStyles from "../assets/showcase-styles.png";
import showcaseExport from "../assets/showcase-export.png";

import FeatureRow from "../components/feature-row";
import React, { useEffect, useState } from "react";
import { ReactComponent as AppStoreIcon } from "../assets/download-app-store.svg";

function HomePage() {
  const matches = true;
  // const [matches, setMatches] = useState(
  //     window.matchMedia("(min-width: 667px)").matches
  // )

  // useEffect(() => {
  //     window
  //         .matchMedia("(min-width: 667px)")
  //         .addEventListener('change', e => setMatches(e.matches));
  // }, []);

  return (
    <div style={{ justifyContent: "center", display: "flex", width: "100%" }}>
      <div style={{ maxWidth: "1440px" }}>
        <Grid container spacing={10} columns={{ xs: 12, sm: 12, md: 12 }}>
          <Grid container item justifyContent={"center"}>
            <Grid
              container
              item
              direction={"row"}
              md={12}
              lg={10}
              justifyContent={"center"}
            >
              <Grid item md={2} sm={1} xs={0} />
              <Grid item md={10} sm={8} xs={10}>
                <div className={"headline-title"}>
                  Logofy - AI Logo Maker{" "}
                  <span style={{ color: "#8E8E93" }}>
                    Craft unique, professional logos instantly with the power of
                    AI.
                  </span>
                </div>
              </Grid>
            </Grid>
            <Grid item md={8} sm={7} xs={10} lg={8}>
              {!matches && (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <div
                    style={{
                      height: "48px",
                      width: "144px",
                      marginTop: "20px",
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                    }}
                  >
                    <a
                      href={
                        "https://apps.apple.com/us/app/visoir-photo-graphic-design/id1619517603"
                      }
                    >
                      <AppStoreIcon style={{ width: "100%", height: "100%" }} />
                    </a>
                  </div>
                </div>
              )}
            </Grid>
          </Grid>
          <div className={"spacer"} />
          <Grid container item justifyContent={"center"}>
            <FeatureRow
              image={showcasePrompt}
              title={"Generate Unique Logo Concepts"}
              subtitle={
                "Describe your brand to instantly generate dozens of custom logo ideas in seconds. Find the perfect match without the hassle."
              }
            />
          </Grid>
          <div className={"spacer"} />
          <Grid container item justifyContent={"center"}>
            <FeatureRow
              image={showcaseStyles}
              title={"Explore Diverse Styles & Templates"}
              subtitle={
                "Browse a wide range of logo styles, from modern minimalist to classic vintage. Choose a premade template as a starting point or let AI inspire you."
              }
              left
            />
          </Grid>
          <div className={"spacer"} />
          <Grid container item justifyContent={"center"}>
            <FeatureRow
              image={showcaseExport}
              title={"Professional Assets Ready-to-Use"}
              subtitle={
                "Download high-resolution logo files suitable for websites, print, merchandise, and more. Get everything you need to build your brand."
              }
            />
          </Grid>
          <div className={"spacer"} />
          <Grid container item justifyContent={"center"}>
            <Grid
              container
              item
              direction={"row"}
              md={12}
              lg={10}
              justifyContent={"center"}
            >
              <Grid item md={2} sm={1} xs={0} />
              <Grid item md={10} sm={8} xs={10}>
                <div
                  className="feature-list-title"
                  style={{ paddingBottom: "40px" }}
                >
                  Unlock Your Brand's Potential
                </div>
                <div className={"feature-list-item"}>
                  AI-powered design suggestions
                </div>
                <div className={"feature-list-item"}>
                  High-resolution vector files
                </div>
                <div className={"feature-list-item"}>
                  Full commercial usage rights
                </div>
              </Grid>
            </Grid>
          </Grid>
          <div className={"spacer"} />
          <Grid container item justifyContent={"center"}>
            <Grid
              container
              item
              direction={"row"}
              md={12}
              lg={10}
              justifyContent={"center"}
            >
              <Grid item md={2} sm={1} xs={0} />
              <Grid item md={10} sm={8} xs={10}>
                <div className="feature-list-title">Available on iPhone</div>
                {!matches && (
                  <>
                    <div
                      style={{
                        height: "48px",
                        width: "144px",
                        marginTop: "20px",
                        marginBottom: "60px",
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                    >
                      <a
                        href={
                          "https://apps.apple.com/us/app/visoir-photo-graphic-design/id1619517603"
                        }
                      >
                        <AppStoreIcon
                          style={{ width: "100%", height: "100%" }}
                        />
                      </a>
                    </div>
                    <div className={"spacer"} />
                  </>
                )}

                <div className={"feature-list-item"}>
                  For feedback or support, contact us at{" "}
                  <a
                    href={"mailto:apps@contractsq.com"}
                    style={{ color: "#BB86FC" }}
                  >
                    apps@contractsq.com
                  </a>
                </div>
                <div className="feature-list-item">© 2025 Logofy</div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

export default HomePage;
